import { CalendarItem } from "./calendar-item";
import { CALENDAR_DAY_HEADER_HEIGHT, type CalendarDayBaseProps } from "./shared";

/** Props Interface */
interface CalendarDayAllDayContentProps<T extends object = object>
	extends CalendarDayBaseProps<T> {}

export function CalendarDayAllDayContent({ item }: CalendarDayAllDayContentProps) {
	return (
		<div
			className="border-y-[0.5px] border-color sticky top-0 z-10 card-bg p-2 overflow-y-auto"
			style={{
				top: CALENDAR_DAY_HEADER_HEIGHT + 0.5,
			}}
		>
			{item.items
				.filter((item) => item.durationType === "all-day")
				.map((calendarItem) => (
					<CalendarItem
						key={calendarItem.id}
						item={calendarItem}
						date={item.date}
					/>
				))}
		</div>
	);
}
